<div class="page-background" fxLayout="column" fxLayoutAlign="start none" fxLayoutGap="10px" fxFlexFill>
    <div class="custom-page-header page-header-text" fxLayout="row" fxLayoutAlign="start center" fxFlex="100px">
        {{title}}
    </div>
    <div fxLayout="row" fxLayoutAlign="center start" fxFlex>
        <div class="body-container">
            <div class="site-agreement-header" fxAlign="center start">
                <p class="big-text">One last thing and then we're done!</p>
                <p class="medium-text">
                    Please take a moment to read the site agreement, and, if it works for you, click the Accept button. After
                    this, you'll be taken to the main screen.
                </p>
            </div>
            <div fxLayout="column" fxLayoutAlign="center center" class="site-agreement-container">
                <div fxLayoutAlign="center center" fxFlex="50px">No Nonsense Site Use Agreement</div>
                <div class="scroll"  [innerHTML]="agreement"></div>
                <div  fxLayout="row"fxLayoutAlign="center center" fxLayoutGap="20px" fxFlex="50px">
                        <button mat-stroked-button (click)="onAcceptAgreement()" >Accept</button>
                        <button mat-stroked-button (click)="onShowLandingScreen()">Decline</button>
                </div>
            </div>
        </div>
    </div>
</div>